export default function formatShortSectorName(sectorName: string) {
  if (sectorName.length > 3) {
    return sectorName
      .split(' ')
      .map(it => it[0])
      .join('');
  } else {
    return sectorName;
  }
};